import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFLookupVendorCustomer } from "../../../Shared/NewForms/NFLookupVendorCustomer";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFLookupBank } from "../../../Shared/NewForms/NFLookupBank";
import { NFLookupCurrency } from "../../../Shared/NewForms/NFlookupCurrency";
import { useTranslation } from "react-i18next";

const BankAccountVendorCustomeMainDetail = () => {
  const { t } = useTranslation();
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Name")} fieldName={"name"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("UniqueCode")} fieldName={"uniqueCode"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupVendorCustomer fieldName={"vendorCustomerId"} title={t("Vendor/Customer")} required />
        </Col>
        <Col sm={6}>
          <NFDateInput fieldName={"createdDate"} title={t("Created Date")} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupBank fieldName={"bankId"} title={t("Bank")} />
        </Col>
        <Col sm={6}>
          <NFLookupCurrency fieldName={"currencyId"} title={t("Currency")} />
        </Col>
      </Row>
    </>
  );
};

export default BankAccountVendorCustomeMainDetail;
